import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {downloadResponseAsFile} from '@brunata-angular/util';
import {DateTime} from 'luxon';
import {Observable} from 'rxjs';
import {ExportFileFormat} from '../models/export-file-format.model';
import {outputFormatFileMeta, SavedExportOutputFormat} from '../models/output-format.model';

export function meterValuesReportFileName(date: DateTime, format: SavedExportOutputFormat): string {
    const {extension} = outputFormatFileMeta[format];
    return `BrunataAcrossSystems-Meter-Values-Report-${date.toFormat('dd-MM-yyyy')}.${extension}`;
}

@Injectable({
    providedIn: 'root',
})
export class MeterValuesReportService {
    private readonly baseUrl = environment.onlineServiceUrl;

    private http = inject(HttpClient);

    downloadMeterValuesReport(
        date: DateTime,
        language: string,
        format: SavedExportOutputFormat,
        timeZone: string,
        fileFormat: ExportFileFormat,
        consumptionOnly = false,
    ): Observable<unknown> {
        const {mimeType} = outputFormatFileMeta[format];
        const {decimalPrecision, ...settings} = fileFormat;
        return this.http
            .get(`${this.baseUrl}/buildings/metervaluesreport`, {
                params: {
                    date: date.toISO() ?? '',
                    language,
                    export: format,
                    timeZone,
                    consumptiononly: consumptionOnly,
                    ...settings,
                    ...(decimalPrecision === null ? {} : {decimalPrecision}),
                },
                observe: 'response',
                responseType: 'blob',
                withCredentials: true,
            })
            .pipe(downloadResponseAsFile(() => meterValuesReportFileName(date, format), mimeType));
    }
}
